// extracted by mini-css-extract-plugin
module.exports = {"root":"layout-module--root--1SL_d","slider":"layout-module--slider--2fLGA"};